module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner5.a5c5efa9.jpg";